// Contains route path constants

import { User } from "react-feather";

export const routes = {
  Home: `/`,
  Login: `/login`,

  //Pages
  Sample: `/sample-page`,

  AllUsers: `/all-users`,

  UserDashboard: `/dashboard-user`,
  //Other
  ErrorPages: {
    Error404: `/error-pages/error-404`,
  },

  OtpVerify: `/otp/verfiy`,

  UserLookup: `/userlookup`,

  UserEditBase: "/users/edit", // ← base
  UserEdit: "/users/edit/:id", // ← full pattern for the router

  UserDetailBase: "/users",
  UserDetail: "/users/:id",

  InstrumentDetail: "/instrument/detail",

  AddDevice: "/devices/add",
};

export default routes;
